import React, { useState, useEffect } from 'react';
import { ascending } from 'd3-array';
import ChartDispersion from './ChartDispersion';
import { fetchData } from './FetchData';

function filterData(data) {
  return data.filter((d) => {
    return true;
  });
}

function prepareChartDispersionData(data) {
  // usually more wrangling is required but the example data is simple
  return data;
}

const useData = (dataSet) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);

  useEffect(() => {
    const fetchNewData = async () => {
      try {
        setLoading(true);
        setError(false);
        const data = await fetchData(dataSet);
        const dataClean = filterData(data);
        setData(prepareChartDispersionData(dataClean));
        setLoading(false);
      } catch (err) {
        console.log(err);
        setError(err);
        setLoading(false);
      }
    };
    fetchNewData();
  }, [dataSet]);

  return [data, loading, error];
};

const ChartDispersionData = ({ array, date }) => {
  const [dataSet, setDataSet] = useState('dataDispersion');
  const [data, loading, error] = useData(dataSet);

  return (
    <>
      <ChartDispersion
        array={array}
        data={data}
        date={date}
        error={error}
        loading={loading}
      />
    </>
  );
};

export default ChartDispersionData;
